var map = {
	"./checked.svg": 8958,
	"./data-catching.svg": 6615,
	"./data.svg": 8699,
	"./dot.svg": 300,
	"./eth.svg": 9392,
	"./exchange.svg": 3052,
	"./explorer.svg": 6354,
	"./finance.svg": 3019,
	"./gafi.svg": 4588,
	"./gaming.svg": 1548,
	"./git.svg": 4733,
	"./github.svg": 1314,
	"./graphql.svg": 4250,
	"./infrastructure.svg": 7502,
	"./insurance.svg": 1705,
	"./more-case.svg": 7733,
	"./openmark.svg": 3880,
	"./p2p.svg": 4787,
	"./social.svg": 7434,
	"./subnet.svg": 5044,
	"./substrate.svg": 7524,
	"./twitter.svg": 6224,
	"./wrech.svg": 9764
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2121;